import type { JSX } from 'react';

export const ORGANIC_LABEL = 'орг.';
export const PAID_LABEL = 'тарг.';

function ValueLine({ label, value }: { label: string; value: number | null }): JSX.Element {
  return (
    <span className="inline-flex items-baseline gap-1.5 justify-end w-full whitespace-nowrap">
      <span className="text-[11px] text-muted-foreground shrink-0">{label}</span>
      <span className={value === null ? 'text-muted-foreground' : undefined}>
        {value === null ? '—' : value.toLocaleString()}
      </span>
    </span>
  );
}

/**
 * Число метрики в таблице статистики.
 *
 * Без рекламной разбивки — одно число, ровно как было, чтобы у аккаунтов без
 * подключённого кабинета таблица не изменилась. С разбивкой — две строки:
 * органика сверху, продвижение снизу.
 */
export function PaidSplitCell({
  organic,
  paid,
  showPaid,
}: {
  organic: number;
  paid: number | null | undefined;
  showPaid: boolean;
}): JSX.Element {
  if (!showPaid) return <>{organic.toLocaleString()}</>;

  return (
    <div className="flex flex-col items-end leading-snug">
      <ValueLine label={ORGANIC_LABEL} value={organic} />
      <ValueLine label={PAID_LABEL} value={paid ?? null} />
    </div>
  );
}
